import { render } from "./CreateRoomModal.vue?vue&type=template&id=5ed3697b"
import script from "./CreateRoomModal.vue?vue&type=script&lang=js"
export * from "./CreateRoomModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__